module.exports = __webpack_public_path__ + "7bad1af5a9031d00fd4d5894d726df5a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-3.png
// module id = 1542
// module chunks = 0